export type { HeatMapTypes, XAxisLabel } from './Types';
export { default as HeatMapUtils } from './utils';
